import React from 'react';
import { SurveyAccountsContextType } from '@myriadgenetics/mgh-types';

export const SurveyAccountsContext = React.createContext<SurveyAccountsContextType | null>(null);
